import { Fragment, useContext, useEffect } from "react";

import { IParentData } from "../../../analytics/pages/report-details/report-details";
import NormalTable, { ITableRowData, IColumn, IScale } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import { IBlock } from "../../../shared/components/widgets-layout/widgets-layout";
import AuthContext from "../../../shared/context/auth-context";
import {useHttpNonTable} from "../../../shared/hooks/use-httpNonTable";
import { postSingleNonTable } from "../../../shared/utils/api";
import { validateLoadingStatusNew, convertKeyIntoName } from "../../../shared/utils/utils";

export interface IRowStatus {
  opt_thresh_id?: string,
  approved_id?: string
}

export interface ITableConfig {
    unblockInput?: boolean;
    allColumns?: {
      displayName: string;
      key: string;
    }[];
    dataUrl?: string;
    hideButtons: string[];
    allStatus?: string | null;
    hideSearchInput?: boolean;
    allStatusDelete?: string | null;
    hideCheckBoxes?: boolean;
    timeframeStartTilEnd?: boolean;
    clickRowToSelectMode?: boolean;
    scale?: IScale;
    lock?: boolean;
    widgetData?: IBlock;
    selectedThreshold?: string;
    selectedSource?: string;
    defaultSortCol?: string;
    orderSettings?: IParentData;
    initiallySelectedRowsIds?: string[];
    draggingStarted?: boolean;
    statusFields?: IRowStatus;
    getResultDataByColsStatus?: string | null | undefined;
    widgetId?: string;
    tobeDeselected?: string[];
    lastChangedWidget?: ITableRowData;
    verticallyHighlighted?: string[];
    getDraggingStatus?: (toggle: boolean) => void;
    getSelectedRowsData?: (data: ITableRowData[]) => void;
    handleOnDelete?: (ids: string[]) => void;
    getNewColumnsOrder?: (data: IParentData, order: IColumn[]) => void;
    renderExtraColumns?: (id: string) => JSX.Element;
  }

const ModelManagementTableHoc = ({allColumns, widgetData, lock, tobeDeselected, verticallyHighlighted, initiallySelectedRowsIds, orderSettings, getDraggingStatus, draggingStarted, getNewColumnsOrder, scale, allStatus, hideButtons, clickRowToSelectMode, hideCheckBoxes, hideSearchInput, unblockInput, getSelectedRowsData, dataUrl }: ITableConfig) => {
  const authCtx = useContext(AuthContext);

  const { sendRequest: getHistoryDataSortBy, status: getHistoryDataStatus, data: getHistoryDataData } = useHttpNonTable(postSingleNonTable, false, authCtx.token, undefined, "analytics");

  const getRecordHandler = (sortingQuery?: string) => {
    let columns = widgetData?.settings?.selectedColumns || [];
    if (!columns.find(c => c === "timeframe_value")) {
      columns = columns ? [...columns, "timeframe_value"] : ["timeframe_value"];
    }
    getHistoryDataSortBy(`model_performance${sortingQuery ? sortingQuery : "?order_by=first_day_of_week asc"}`, {
      columns: columns,
      dataset_id: widgetData?.settings?.dataset_id,
      timeframe: widgetData?.settings?.timeframe,
    }, undefined, "none");
  };

  useEffect(() => {
    getRecordHandler();
  }, [widgetData]);

  const sortByRecord = (sortingQuery: string) => {
    getRecordHandler(sortingQuery);
  };

  const renderTable = () => {
    if (!allColumns) {
      return;
    }
    const resultRecord = {rows: getHistoryDataData ? getHistoryDataData.data : []};

    if (widgetData?.settings?.selectedColumns && !widgetData?.settings?.selectedColumns?.find(c => c === "timeframe_value")) {
      widgetData.settings.selectedColumns = ["timeframe_value", ...widgetData.settings.selectedColumns];
    }

    const columns:IColumn[] = widgetData?.settings?.selectedColumns?.map((col:string) => {
      const columnDisplayName = allColumns.find((c) => c.key === col)?.displayName || convertKeyIntoName(col);
      return { key: col, displayName: columnDisplayName, dataType: { type: "text" } };
    }) || [];

    return (
      <Fragment>
        {validateLoadingStatusNew([getHistoryDataStatus]) && <Spinner />}
        <NormalTable
          sortBy={sortByRecord}
          draggingStarted={draggingStarted}
          getDraggingStatus={getDraggingStatus}
          columns={columns}
          verticallyHighlighted={verticallyHighlighted}
          fetchedData={getHistoryDataStatus=== "completed" ? resultRecord : {rows : []}}
          allStatus={allStatus}
          dataUrl={dataUrl}
          orderSettings={orderSettings}
          editColumsOrder={!lock}
          timeFrameIsAstring={true}
          getNewColumnsOrder={getNewColumnsOrder}
          defaultSortCol={"timeframe_value"}
          tobeDeselected={tobeDeselected}
          hideSearchInput={hideSearchInput}
          initialySelectedRows={initiallySelectedRowsIds}
          hideCheckBoxes={hideCheckBoxes}
          getSelectedRowsData={getSelectedRowsData}
          unblockInput={unblockInput}
          clickRowToSelectMode={clickRowToSelectMode}
          hideButtons={hideButtons}
          scale={scale}
        />
      </Fragment>
    );
  };

  return <Fragment>{renderTable()}</Fragment>;
};

export default ModelManagementTableHoc;